import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { Status } from './general.model';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';

export class Circular {
    Id: number;
    CircularNo: string;
    Symbol: string;
    NameEN: string;
    URL: string;
    ExpirationdependsOnETA: boolean; // used in sailing date validation
};
export class CircularNotification {
    Id: number;
    CircularNo: string;
    Symbol: string;
    NameEN: string;
    URL: string;
    NotificationCount: number
};


export class Port {
    Id: number;
    NameEN: string;
    NameAR: string;
    CountryId: number;
};
export class OptionKey {
    Index: number;
    Text: string;
    Value: number;
}; export class PercentageKey {
    Index: number;
    Text: string;
    Value: number;
    Percentage: string;
    //Port : string;
};
export class CircularOptionRebate {
    Id: string;
    RebatePercentage: string;
    Notes: string;
    MeasurementDecisionId: number | null;
    MeasurementRejectionReason: string;
    CreationDate: string;
};

export class Regions {
    ID: number
    NameEN: string;
    Direction: string
    Description: string
}
export class Percentages {
    Id: number;
    CircularsLookupId: number;
    PercentageValue: string;
    IsDeleted: boolean;
    RegionsId: number;
    FromRegionId: number;
    CircularsRegions: Regions;
    CircularsRegions1: Regions;
}
export class RelatedRequests{
    Id: string;
    RebateFileNumber:string;
    RequestNumber:string;
    serviceName:string;
    Status:string;
    DecisionDate:string;
    SailDirection:string;
    LastTransitDateString:string;
}
export class CircularRequest {
    DecisionDate:string;
    CircularsLookup : Circular;
    CircularsLookupId: number;
    ActivityInstanceID: string;
    RequestorEmail: string;
    Id: string;
    OperatorName: string;
    OperatorEmail: string;
    VesselName: string;
    VesselTypeId: Number;
    ExNames: string;
    YearBuilt: string;
    IsScrubberFitted: boolean | null;
    MainEngineFuelId: number | null;
    OtherMainEngineFuel: string;
    EngineType: boolean | null;
    BunkeringPort: string;
    CallSign: string;
    IMONo: string;
    DWT: string;
    SCNT: string;
    SCID: string;
    AdminExNames:string;
    LastTransitDate: string;
    DateOfSailing: string;
    ETASC: string;
    ETD: string;
    LastTranETDsitDate: string;
    OriginRegionId: number;
    RequireModificationRecentComment: CircularComment;
    CargoKind: string;
    CargoQuantity: string;
    Note: string;
    Name: string;
    EMail: string;
    Email: string;
    Fax: string;
    InternalStatusId?: number;
    ExternalStatusId?: number;
    CreatedBy: string;
    CreationDate: string;
    ModifiedBy: string;
    ModifiedDate: string;
    IsDeleted: boolean;
    IsEditable: boolean;
    FileNumber: string;
    IsShipPassed: boolean;
    hasRequestorDecision: boolean;
    PassingDate: Date;
    RebateStatusId: number;
    IsCanceled: boolean;
    CancelationReason: string;
    CancelationMessage: string;
    IsRefunded: boolean;
    RefundedPercentageId: number;
    IsClosed: boolean;
    RequestorId: string;
    ServiceId: number;
    StatusId: number;
    CircularsFixedRebateOptions: CircularsFixedRebateOptions[];
    BaseRequest: BaseRequest;
    Status1: Status;
    CanClone: boolean;
    IsSubmitClone: boolean;
    IsSubRequest: boolean;
    IsShipLoaded: boolean;
    ParentRequestNumber: string;
    CanPerformAcurateDataForm: boolean = false;
    CanPerformAdminActions: boolean = false;
    LastTransitDateString: string;
    AdminSCID: string;
    RequestorDecisionRejectionReason: string;
    RebateFileNumber: string;
    AdminRejectionReason: string;
};
export class CircularsFixedRebateOptions {
    Id: string;
    CircularFixedRebateRequestId: string;
    CircularsPercentagesId: number;
    ActualSpeed: string;
    LastCountryOriginId: number;
    LastPortOriginId: number | null;
    FirstCountryDestinationId: number;
    FirstPortDestinationId: number | null;
    OtherLastPortOrigin: string;
    OtherFirstPortDestination: string;
    SailDirectionId: number;

    FromRegionId: number;
    //ETD: string;
    //ETASC: string;
    //DateOfSailing: string;
    IFOTon: string;
    IFOTonPrice: string;
    DOTon: string;
    IsUsedInPassing: boolean;
    IsGranted: boolean;
    DOTonPrice: string;
    isGranted: boolean;
    ApprovalNote: string;
    CreatedBy: string;
    CreationDate: string;
    ModifiedBy: string;
    ModifiedDate: string;
    IsDeleted: boolean;
    SailDirection: SailDirection;
    IsOptionAdminDone: boolean = false;
};

export class CircularComment {
    Id: string;
    CircularRequestId: string;
    CircularsLookupId: number;
    CommentTypeId: number;
    Comment: string;
    CreatedBy: string;
    CreationDate: string;
    ModifiedBy: string;
    ModifiedDate: string;
    IsDeleted: boolean;
    CommenterTypeId: number;
};

export class StepDecision {
    Id: string;
    CircularFixedRebateRequestId: string;
    ActionType: number;
    SecondStep_WFaction: number;
    comment: string;
    SCID: string;
    ExNames:string;
    ActivityInstanceID: string;
    AdminEmail: string;
    CircularsFixedRebateOptionDecisionHistory: CircularsFixedRebateOptionDecisionHistory[];
    StepName: string;
};

export class CircularsFixedRebateOptionDecisionHistory {
    CircularFixedRebateRequestId: string;
    CircularsPercentagesId: string;
    CircularsFixedRebateOptionsId: string;
    CircularFixedRebateDecisionsId: string;
    Notes: string;
    isGranted: boolean = false;
}
